import React from 'react';
import { compose } from 'ramda';

import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import styleFile from './AvailMainSideSummaryGiftCodeDiscount.js';
import { RichText } from '@synergycms_core/components/generic';
import { withContent } from '@synergycms_core/components/providers/translateProvider';
import Price from '@synergycms_core/components/generic/Price';
import validateAsyncComponent from '@synergycms_core/components/HoC/validateAsyncComponent';
import connect from 'react-redux/es/connect/connect';

const AvailMainSideSummaryGiftCodeDiscount = class AvailMainSideSummaryGiftCodeDiscount extends React.Component {
  static displayName = 'AvailMainSideSummaryGiftCodeDiscount';

  render() {
    const { config, theme } = this.props,
      {
        giftCodeDiscount,
        giftCode,
        stepCode,
      } = config;

    const { classes } = theme.styles;

    return (
      <div className={classes.contentModuleRow}>
        <div className={classes.contentModuleCellName}>
          <RichText text={giftCode} innerStyle={['roboto16BoldBlack400', 'uppercase', 'blue', classes.textoverflow]} />
        </div>
        <div className={classes.contentModuleCellPrice}>
          <Price
            innerStyle={['summaryPriceMedium', 'blue', classes.textPrice].join(' ')}
            amount={giftCodeDiscount}
            forceHotelCurrency={stepCode === 'confirmation'}
          />
        </div>
      </div>
    );
  }
};

const mapStateToProps = (store, ownProps) => {
  return {
    stepCode: store.getIn(['customer', 'step', 'current_step', 'code']),
  };
};

export default compose(
  validateAsyncComponent(mapStateToProps),
  connect(
    mapStateToProps,
  ),
  PropertyManager([
    'giftCodeDiscount',
    'giftCode',
    'stepCode',
  ]),
  withThemeJSS({ styleFile, link: true }),
  withContent('i18n')
)(AvailMainSideSummaryGiftCodeDiscount);
